import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {CampusProofCard} from '../ProofEdit/CampusProofCard';
import {Checkbox} from '../Components/Checkbox';
import {browserHistory} from 'react-router';



const inputStyle : CSSProperties = {
    fontFamily: 'AveriaSerifLightItalic',
    fontSize: '12px',
    letterSpacing: '2px',
    margin: 'auto',
    border: '1px solid #A7A7A7',
    boderSpacing: 0,
    height: '200px',
    width: '290px',
    resize: 'none',
    overflowY: 'hide',
    overflowX: 'auto'
}

const checksBoxStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    fontSize: "12px",
    alignSelf: 'center'
}

const cbStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-start',
    fontFamily: 'CenturyGothic',
    fontSize: '11px',
    lineHeight: '20px',
    color: '#777777'
}


let emptyNotesStyle = Object.assign({},inputStyle,{color: 'darkgray', overflow: 'hidden'});


class Props extends Tgcc.BaseProps {
    Notes: string;
    TimeSensitive: boolean;
    Embroidery: boolean;
    ScreenPrint: boolean;
}

class _IndigoNotesEdit extends React.Component<Props, any>{


    state = {
        Notes: "",
    };

    componentWillMount(){
        this.setState({Notes: this.props.Notes});
    }
    componentWillReceiveProps(newProps: Props){
        this.setState({Notes: newProps.Notes});
    }
    emptyClick = (evt: React.SyntheticEvent<HTMLTextAreaElement>) =>{
        evt.currentTarget.value = "";
    }
    emptyBlur = (evt: React.SyntheticEvent<HTMLTextAreaElement>) =>{
    }
    editStart = (evt: React.SyntheticEvent<HTMLTextAreaElement>) =>{
        this.noteChanged(evt);
    }
    noteChanged = (evt: React.SyntheticEvent<HTMLTextAreaElement>) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateProofNotes, payload: evt.currentTarget.value});
    }


    render() {
        var notes = this.state.Notes || '';
        var textEdit = notes ? 
                    <textarea name="existingNotes"
                        className="hoverBorder"
                        style={inputStyle}
                        value={notes}
                        onChange={this.noteChanged}>
                    </textarea>
                    :
                    <textarea
                        name="emptyNotes"
                        className="hoverBorder"
                        style={emptyNotesStyle}
                        onClick={this.emptyClick}
                        onChange={this.editStart}
                        placeholder="Please enter any additional information and description here. Specific details are great and will help us quickly create a design that will meet your needs. Thanks!"></textarea>

        return (
            <div>
                <CampusProofCard title='4. Additional Notes'>
                    {textEdit}
                </CampusProofCard>
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return {
        Notes: state.ActiveProof.notes || "",
    }
}

export var IndigoNotesEdit = connect(mapStateToProps)(_IndigoNotesEdit);
